import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { getMessagemErro } from "../../utils/erro";
import api from "../../services/api";
import { getUrlRetorno } from "../../utils/itiUtil"
import { base64ToStr } from "../../utils/base64Util";
import qs from 'query-string';
import './AutoCadastroUsuario.css';
import { PdfSigner } from "../PdfSigner/PdfSigner";
import { ModalMensagemFinalizacao } from "./ModalMensagemFinalizacao";
 
const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const pathRetorno = "/user-self-registration/sign";

const CryptoJS = require("crypto-js");

export const AutoCadastroUsuarioSigner =
withRouter(

// redux
connect(
	(null), 
	(mapDispatchToProps)
)(
	class extends Component {

		constructor(props){
			super(props);
			this.state = {
                solicitacao: {},
				termoResponsabilidadePDF : '',
                nomeArquivo: '',
				botoesHabilitados : true,
				exibeModalMensagem: false,
			};

			this.assinaTermoResponsabilidade = this.assinaTermoResponsabilidade.bind(this);
			this.getState = this.getState.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
						<Message />
						<Loading />
						
						<div  style={{margin: "10px"}}>
							<h1>Assinar Solicitação de Cadastro de Usuário</h1>
						</div>

					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();

			const id = this.props.match.params.id;
            if(! id || (isNaN(id))){
                this.props.exibeMensagemErro("Id da Solicitação não informado corretamente");
                return;
            }

			const state = localStorage.getItem('state');

			const urlParams = qs.parse(this.props.location.search);
			const code = urlParams.code;
			const error = urlParams.error;

			if((code || error) && state){
				const objState = JSON.parse(base64ToStr(state));
				this.setState(objState);

				const hashPdfOriginal = this.getHashEmBase64(objState.termoResponsabilidadePDF);
				if(!error){
					const body = {
						tipoCertificado: objState.tipoCertificado,
						urlRetorno: getUrlRetorno(`${pathRetorno}/${id}`),
						code, 
						hashPdfOriginal,
					}
					this.assinaTermoResponsabilidade(body);
				}
				return;
			} 

			this.carregaSolicitacao();
            this.baixartermoResponsabilidadePDF();
		}

		renderForm() {
            const {solicitacao, termoResponsabilidadePDF, nomeArquivo, botoesHabilitados, exibeModalMensagem} = this.state;
			return(
                <Fragment>
                    <div className="container-fluid">
						<ModalMensagemFinalizacao visible={exibeModalMensagem} solicitacao={solicitacao} handleClose={() => this.setState({ exibeModalMensagem:false })}/>
						
					    <div className="br-form">
							<PdfSigner pdf={termoResponsabilidadePDF} 
								nomeArquivo={nomeArquivo} 
								botoesHabilitados={botoesHabilitados} 
								assinaturaHabilitada={solicitacao.assinaturaPermitida} 
								onAssinar={this.assinaTermoResponsabilidade}
								pathRetorno={`${pathRetorno}/${solicitacao.id}`}
								stateParent={this.getState}
								/>
                        </div>
                    </div>
					
                </Fragment>
			);
		}

		carregaSolicitacao(){
			api.get('/api/auto-cadastro-usuario')
				.then(response => { 
					this.setState({solicitacao: response.data}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar a solicitacao de cadastro de usuário ", erro)
					this.props.exibeMensagemErro("Erro durante o carregamento da página")
				});
		}

		baixartermoResponsabilidadePDF(){
            const options = {
				method: 'post',
				url: '/api/auto-cadastro-usuario/termo-responsabilidade/pdf',
				responseType: 'arraybuffer'
			}

			this.props.limpaMensagem();
			this.props.mostraAguardando();
			this.setState({ botoesHabilitados : false });

			api(options)
				.then((response) => {
                    let nomeArquivo = 'TermoResponsabilidade.pdf';

					const contentDisposition = response['headers']['content-disposition'];
					if(contentDisposition) {
						nomeArquivo = contentDisposition.split("filename=")[1];
					}

					const termoResponsabilidadePDF = Buffer.from(response.data).toString('base64')

                    this.setState({
                        termoResponsabilidadePDF, 
                        nomeArquivo,
                    })
				})				
				.catch(response => {
					const erro = {data: JSON.parse(Buffer.from(response.data).toString('utf8'))};
					const mensagemInicial = 'Não foi possível recuperar o termo de responsabilidade';
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
					this.setState({botoesHabilitados : true});
				});
		}

		getState() {
			const stateCopy = { ...this.state };
			return stateCopy;
		}

		getHashEmBase64(message){
			const messageBuffer = Buffer.from(message, 'base64').buffer;
			const wordArray = CryptoJS.lib.WordArray.create(messageBuffer);
			const hash = CryptoJS.SHA256(wordArray);
			return CryptoJS.enc.Base64.stringify(hash);
		}

		assinaTermoResponsabilidade(body) {
			this.setState({botoesHabilitados:false});
			this.props.mostraAguardando();

			localStorage.removeItem('state');
			body.id = this.props.match.params.id;
			if(!body.hashPdfOriginal){
				const { termoResponsabilidadePDF } = this.state;
				const hashPdfOriginal = this.getHashEmBase64(termoResponsabilidadePDF);
				body.hashPdfOriginal = hashPdfOriginal;
			}

			api.post('/api/auto-cadastro-usuario/assinar', body)
				.then(response => {
					this.baixartermoResponsabilidadePDF();
					this.setState({solicitacao: response.data, exibeModalMensagem: true})
					localStorage.removeItem('stateParentUrl');
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível assinar a solicitação de cadastro de usuário:", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.setState({botoesHabilitados:true});
					this.props.escondeAguardando();
				});
		}

    }
) // redux
); // router